import { cleanupPageMediaForNativePaywall } from '@/lib/native-revenuecat-launch';

const PRE_LAUNCH_FRAME_WAITS = 2;
const POST_CLEANUP_SETTLE_MS = 80;

async function waitForPaints(frameCount: number) {
  if (typeof window === 'undefined') return;

  for (let frame = 0; frame < frameCount; frame += 1) {
    await new Promise<void>((resolve) => {
      window.requestAnimationFrame(() => resolve());
    });
  }
}

export async function stageNativePaywallHandoff(logPrefix = '[RevenueCat]') {
  if (typeof window === 'undefined') return;

  console.log(`${logPrefix} Preparing lightweight native paywall handoff`);

  await waitForPaints(PRE_LAUNCH_FRAME_WAITS);
  cleanupPageMediaForNativePaywall(logPrefix);
  await waitForPaints(1);
  await new Promise((resolve) => window.setTimeout(resolve, POST_CLEANUP_SETTLE_MS));

  console.log(`${logPrefix} Native paywall handoff prepared`);
}

/**
 * Persisted (sessionStorage) lock that prevents the native RevenueCat sheet
 * from being launched twice in quick succession. Survives component remounts
 * and quick route re-entry; dies when the app process is restarted.
 */
const PAYWALL_LOCK_KEY = 'buxbox:native_paywall_lock';
const DEFAULT_LOCK_MS = 45_000;

export function acquireNativePaywallLock(ms: number = DEFAULT_LOCK_MS): boolean {
  if (typeof window === 'undefined') return true;
  try {
    const now = Date.now();
    const prev = Number(window.sessionStorage.getItem(PAYWALL_LOCK_KEY) || 0);
    if (prev && now - prev < ms) return false;
    window.sessionStorage.setItem(PAYWALL_LOCK_KEY, String(now));
    return true;
  } catch {
    return true;
  }
}

export function releaseNativePaywallLock(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(PAYWALL_LOCK_KEY);
  } catch {
    /* ignore */
  }
}